import { getEditLocation } from "../../../core/util/functions";

export const productGroupsLocation = "/listing/codebook/productgroups";
export const getProductGroupEditLocation = (id?: string) =>
	getEditLocation(productGroupsLocation, undefined, id);

export const editRouter = getProductGroupEditLocation(":groupId?");
